/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Push_Notsubscribed1Inputs */

const id_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak berlangganan`)
};

const ms_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak dilanggan`)
};

const da_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikke abonneret`)
};

const de_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht abonniert`)
};

const en_us2_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not subscribed`)
};

const es_es2_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No suscrito`)
};

const es_mx2_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No suscrito`)
};

const fil_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi naka-subscribe`)
};

const fr_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non abonné`)
};

const it_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non iscritto`)
};

const hu_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincs feliratkozva`)
};

const nl_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niet geabonneerd`)
};

const no_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikke abonnert`)
};

const pl_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie subskrybowany`)
};

const pt_br2_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not subscribed`)
};

const pt_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não subscrito`)
};

const ro_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neabonat`)
};

const fi_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei tilattu`)
};

const sv_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenumererar inte`)
};

const vi_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa đăng ký`)
};

const tr_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abone değil`)
};

const cs_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nepřihlášeno`)
};

const bg_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не е абониран`)
};

const ru_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не подписан`)
};

const uk_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не підписано`)
};

const ar_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غير مشترك`)
};

const hi_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सब्सक्राइब नहीं`)
};

const th_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่ได้สมัครรับ`)
};

const ja_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未購読`)
};

const zh_cn2_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not subscribed`)
};

const zh_hant1_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not subscribed`)
};

const ko_notifications_push_notsubscribed1 = /** @type {(inputs: Notifications_Push_Notsubscribed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독되지 않음`)
};

/**
* | output |
* | --- |
* | "Not subscribed" |
*
* @param {Notifications_Push_Notsubscribed1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_push_notsubscribed1 = /** @type {((inputs?: Notifications_Push_Notsubscribed1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Push_Notsubscribed1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_push_notsubscribed1(inputs)
	if (locale === "ms") return ms_notifications_push_notsubscribed1(inputs)
	if (locale === "da") return da_notifications_push_notsubscribed1(inputs)
	if (locale === "de") return de_notifications_push_notsubscribed1(inputs)
	if (locale === "en-US") return en_us2_notifications_push_notsubscribed1(inputs)
	if (locale === "es-ES") return es_es2_notifications_push_notsubscribed1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_push_notsubscribed1(inputs)
	if (locale === "fil") return fil_notifications_push_notsubscribed1(inputs)
	if (locale === "fr") return fr_notifications_push_notsubscribed1(inputs)
	if (locale === "it") return it_notifications_push_notsubscribed1(inputs)
	if (locale === "hu") return hu_notifications_push_notsubscribed1(inputs)
	if (locale === "nl") return nl_notifications_push_notsubscribed1(inputs)
	if (locale === "no") return no_notifications_push_notsubscribed1(inputs)
	if (locale === "pl") return pl_notifications_push_notsubscribed1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_push_notsubscribed1(inputs)
	if (locale === "pt") return pt_notifications_push_notsubscribed1(inputs)
	if (locale === "ro") return ro_notifications_push_notsubscribed1(inputs)
	if (locale === "fi") return fi_notifications_push_notsubscribed1(inputs)
	if (locale === "sv") return sv_notifications_push_notsubscribed1(inputs)
	if (locale === "vi") return vi_notifications_push_notsubscribed1(inputs)
	if (locale === "tr") return tr_notifications_push_notsubscribed1(inputs)
	if (locale === "cs") return cs_notifications_push_notsubscribed1(inputs)
	if (locale === "bg") return bg_notifications_push_notsubscribed1(inputs)
	if (locale === "ru") return ru_notifications_push_notsubscribed1(inputs)
	if (locale === "uk") return uk_notifications_push_notsubscribed1(inputs)
	if (locale === "ar") return ar_notifications_push_notsubscribed1(inputs)
	if (locale === "hi") return hi_notifications_push_notsubscribed1(inputs)
	if (locale === "th") return th_notifications_push_notsubscribed1(inputs)
	if (locale === "ja") return ja_notifications_push_notsubscribed1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_push_notsubscribed1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_push_notsubscribed1(inputs)
	return ko_notifications_push_notsubscribed1(inputs)
});
export { notifications_push_notsubscribed1 as "notifications.push.notSubscribed" }